import { ReactElement } from 'react';

import { CAST_AI } from '@cast/constants';

import { WarningTooltip } from './WarningTooltip';

type CastwarePolicyTooltipProps = {
  isCastware?: boolean;
  children: ReactElement;
};

export const CastwarePolicyTooltip = ({
  isCastware = false,
  children,
}: CastwarePolicyTooltipProps) => {
  return (
    <WarningTooltip
      title={`The scaling policy cannot be edited because it contains system workloads only managed by ${CAST_AI}.`}
      followCursor
      testId="castware-tooltip"
      show={isCastware}
    >
      {children}
    </WarningTooltip>
  );
};
